import { NIL as NIL_UUID } from "uuid";
import * as dashboardAlertRulesConstants from "../_constants/dashboard.alertRuleSet.constants";
import * as dashboardAlertRulesApi from "../_services/dashboard.alertRuleSet.service";

export const loadDashboardAlertRuleSetsSuccess = (dashboardAlertRuleSets) => {
    return {
        type: dashboardAlertRulesConstants.LOAD_DASHBOARD_ALERT_RULE_SETS_SUCCESS,
        dashboardAlertRuleSets,
    };
};

export const loadDashboardAlertRuleSets = (venueId) => {
    return async (dispatch) => {
        await dashboardAlertRulesApi
            .getAlertRuleSetsByVenueId(venueId)
            .then(ruleSets => {
                dispatch(loadDashboardAlertRuleSetsSuccess(
                    [{id: NIL_UUID, name: 'No alert'}, ...ruleSets.data ]));
            })
            .catch((error) => {
                throw error;
            });
    };
};